export default {
  genres: 'Genres',
  artists: 'Artists',
  albums: 'Albums',
  tracks: 'Tracks',
  playlist: 'Playlist',
  playlists: 'Playlists',
  unknown_artist: 'Unknown artist',
  unknown_album: 'Unknown album',
  unknown_track: 'Unknown track',
  unknown_playlist: 'Unknown playlist',

  clear: 'Clear',
  download: 'Download',
  order_number: 'Sort',
  shuffle: 'Shuffle',
  undo: 'Undo',
  redo: 'Redo',
  save: 'Save',

  skin_green: 'Green',
  skin_purple: 'Purple',
  skin_dark: 'Dark',

  browser_no_support: 'This browser has no support HTML audio',

  en: 'English',
  es: 'Spanish',
  ru: 'Russian',

  playlist_prompt: 'Playlist name (username:playlist_name)',
  random_playlist: 'Random playlist',
  all_apologies: 'All apologies this is doesn\'t work',

  artists_alphabet: 'A-Z',
  recent_artists: 'Recently added',
}